import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import ClientWaitPrompt from "./platform/ClientWaitPrompt";
import ErrorBoundary from "./ErrorBoundary.tsx";
import { AuthProvider } from "./platform/AuthContext.tsx";
import { QuoteDraftProvider } from "./platform/QuoteDraftContext.tsx";
import "./index.css";
const TvPage = lazy(() => import('./platform/TvPage'));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      {window.location.pathname.startsWith('/tv/') || window.location.pathname === '/tv' ? <Suspense fallback={<div style={{minHeight:'100vh',background:'#100e25'}}/>}><TvPage/></Suspense> :
      <AuthProvider>
        <QuoteDraftProvider>
          <App />
          <ClientWaitPrompt />
        </QuoteDraftProvider>
      </AuthProvider>}
    </ErrorBoundary>
  </StrictMode>,
);
